module.exports = __webpack_public_path__ + "static/img/TW@2x.00f75036.jpg";